
function getWebUrl () {
  var protocol = window.location.protocol
  var hostname = window.location.hostname
  var port = window.location.port
  return protocol + '//' + hostname + ':' + port
}
export const queryNewsPageList = getWebUrl() + '/Admin/WebApi/NewsApi.aspx' // 获取分页新闻动态及行业动态
export const queryNewsList = getWebUrl() + '/Admin/WebApi/NewsApi.aspx' // 获取新闻动态及行业动态
export const findNewsDtl = getWebUrl() + '/Admin/WebApi/NewsApi.aspx' // 获取新闻动态及行业动态详细
export const saveAppeal = getWebUrl() + '/Admin/WebApi/AppealApi.aspx'// 提交试用申请



// WEBPACK FOOTER //
// ./src/api/api.js